export enum ResponseType {
  PING_RESPONSE = 'ping.response',
  AUTH_RESPONSE = 'auth.response',
  SUB_RESPONSE = 'sub.response',
  EVENT = 'event'
}

export enum ResponseStatus {
  SUCCESS = 'OK',
  ERROR = 'ERROR'
}

export interface ResponseHeader {
  type: ResponseType;
  clientId: string;
  messageId: string;
  reqMessageId: string;
  status: string;
  errors: Error[] | null;
}

export interface Error {
  code: string;
  message: string;
}

export interface AuthResponseBody {
  expireTs: Date;
}

export interface SubscribeResponseBody {
  subscriptionId: string;
}

export interface EventBody {
  channel: string;
  subscriptionId: string;
  data: any;
}

export interface ResponseMessage {
  header: ResponseHeader;
  body: AuthResponseBody | SubscribeResponseBody | EventBody | PingResponseBody | null;
}

export interface PingResponseBody {
  pongTz: Date;
}
